<div class="panel">
  <h2>Autres</h2>

  <div class="form-group">
    <label for="id">Identifiant</label>
    <span id="id" class="value">{{ user.id }}</span>
  </div>

  <div class="form-group">
    <label for="created_at">Date d'ajout</label>
    <span id="created_at" class="value">{{ user.created_at | tzdate }}</span>
  </div>
</div>